import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "video-content" }
const _hoisted_2 = { class: "video" }
const _hoisted_3 = ["src", "title"]
const _hoisted_4 = { class: "visually-hidden" }
const _hoisted_5 = {
  key: 0,
  class: "video-date"
}
const _hoisted_6 = {
  key: 1,
  class: "video-description"
}

import { ref, onMounted, computed, watch } from 'vue';
import { useI18n } from 'vue-i18n';
import videoService from '@/services/videoService';
import type { VideoResponse } from '@/types/api';


export default /*@__PURE__*/_defineComponent({
  __name: 'VideoWidget',
  setup(__props) {

const { t, locale } = useI18n();
const video = ref<VideoResponse | null>(null);

const loadVideo = async () => {
  try {
    const lang = locale.value?.slice(0, 2) || 'fr';
    video.value = await videoService.getVideo(lang);
  } catch {
    video.value = null;
  }
};

onMounted(loadVideo);

// watch(
//   () => locale.value,
//   () => {
//     loadVideo();
//   }
// );

const formattedDate = computed(() => {
  if (!video.value?.publishedDate) return '';
  const d = new Date(video.value.publishedDate);
  return d.toLocaleDateString(undefined, {
    day: 'numeric',
    month: 'short',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  });
});

return (_ctx: any,_cache: any) => {
  const _component_cs_widget = _resolveComponent("cs-widget")!

  return (video.value)
    ? (_openBlock(), _createBlock(_component_cs_widget, {
        key: 0,
        class: "widget-video",
        title: _unref(t)('dashboard.VideoTitle')
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("iframe", {
                width: "50%",
                height: "40%",
                src: video.value.link,
                title: video.value.title,
                frameborder: "0",
                allow: "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture",
                allowfullscreen: ""
              }, null, 8, _hoisted_3),
              _createElementVNode("details", _hoisted_4, [
                _createElementVNode("summary", null, _toDisplayString(video.value.title), 1),
                _createElementVNode("p", null, _toDisplayString(video.value.description), 1)
              ])
            ]),
            (formattedDate.value)
              ? (_openBlock(), _createElementBlock("p", _hoisted_5, _toDisplayString(formattedDate.value), 1))
              : _createCommentVNode("", true),
            (video.value.description)
              ? (_openBlock(), _createElementBlock("p", _hoisted_6, _toDisplayString(video.value.description), 1))
              : _createCommentVNode("", true)
          ])
        ]),
        _: 1
      }, 8, ["title"]))
    : _createCommentVNode("", true)
}
}

})